<app-page-content header="Start a project" subtitle="Tell us what you’re building.">
  <input type="text" class="control" placeholder="Your name *" [formField]="form.name" />
  <input type="email" class="control" placeholder="Email address *" [formField]="form.email" />
  <textarea
    [formField]="form.details"
    type="text"
    class="control"
    rows="5"
    placeholder="A couple of notes on what you’re trying to build *"
  ></textarea>
  <button class="btn btn-primary" [disabled]="form().invalid() || submitted()" (click)="submit()">
    Start the conversation
  </button>
</app-page-content>
